import { canUseWindow } from '@/lib/canUseWindow';

export function saveParamsToSession(
  params: URLSearchParams,
  storageKey: string,
) {
  if (!canUseWindow()) return null;

  const { sessionStorage } = window;
  const paramsString = params.toString();

  try {
    sessionStorage.setItem(storageKey, paramsString);
  } catch (e) {
    console.warn(`sessionStorage.setItem failed ${e}`);
    return null;
  }
}

export function clearExistingSessionParams(storageKey: string) {
  if (!canUseWindow()) return null;

  try {
    sessionStorage.removeItem(storageKey);
  } catch (e) {
    console.warn(`sessionStorage.removeItem failed ${e}`);
    return null;
  }
}

export function getSessionParams(storageKey: string) {
  if (!canUseWindow()) return null;

  try {
    return sessionStorage.getItem(storageKey);
  } catch (e) {
    console.warn(`sessionStorage.getItem failed ${e}`);
    return null;
  }
}

export function sessionStorageToObject(storageKey: string) {
  if (!canUseWindow()) return {};

  const { sessionStorage } = window;
  let storageItem: string | null;
  try {
    storageItem = sessionStorage.getItem(storageKey);
  } catch (e) {
    console.warn(`sessionStorage.getItem failed ${e}`);
    return null;
  }

  const result: { [key: string]: string } = {};

  if (storageItem) {
    const params = new URLSearchParams(storageItem);

    params.forEach((value, key) => {
      result[key] = value;
    });
  }

  return result;
}
